import { render, staticRenderFns } from "./FormBox.vue?vue&type=template&id=25964faa&scoped=true&lang=pug"
import script from "./FormBox.vue?vue&type=script&lang=js"
export * from "./FormBox.vue?vue&type=script&lang=js"
import style0 from "./FormBox.vue?vue&type=style&index=0&id=25964faa&prod&lang=scss"
import style1 from "./FormBox.vue?vue&type=style&index=1&id=25964faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25964faa",
  null
  
)

export default component.exports